import React from "react";
import { motion } from "framer-motion";
import { pageVariants } from "../animations/pageTransitions"; // Import animation config
import "./Capabilities.css";
import speccare from "../../practices_images/special-care.jpg"; // Ensure this path is correct
import CollapsibleSection from "./CollapsibleSection"; // adjust path if needed

const SpecializedCare = () => {
  return (
  <motion.div
    variants={pageVariants}
    initial="initial"
    animate="animate"
    exit="exit"
  >
    <div className="cap-container">
    <h1>Specialized Care</h1>

    <div className="cap-section">
        {/* Text Content */}
        <div className="text-content">
            {/* ✅ First 2 sections: normal (always visible) */}
            <h3>Supporting complex care environments with operational discipline</h3>
            <p>
              Specialized care facilities focus on diagnosing and treating complex conditions that require advanced expertise, specialized workflows, and precise coordination across clinical and administrative teams. These environments often involve higher cost services, stricter compliance requirements, and greater financial risk.
            </p>
            <p>
              We partner with specialized care providers to help them operate with clarity, accuracy, and control.
            </p>

            <h3>The Operating Environment</h3>
            <p>
              Specialized care facilities manage intricate clinical pathways, procedure based services, and highly specific documentation and billing requirements. Reimbursement accuracy is critical, as even small errors can have significant financial impact.
            </p>
            <p>
              At the same time, leadership must maintain visibility into performance while ensuring compliance with evolving regulatory and payer standards.
            </p>

            {/* ✅ Everything after: collapsible */}
            <CollapsibleSection title="Our Role">
              <p>
                We help specialized care facilities strengthen the operational and financial foundations that support complex care delivery.
              </p>
              <p>
                Our work focuses on reinforcing documentation and coding accuracy, supporting reliable billing and reimbursement processes, improving financial visibility, and strengthening compliance and internal controls. We also support technology and security practices that protect sensitive patient data and enable operational continuity.
              </p>
              <p>
                Our approach reflects the complexity and scale of specialized care environments.
              </p>
            </CollapsibleSection>

            <CollapsibleSection title="Enabling Control and Sustainability">
              <p>
                Our goal is to help facilities operate with confidence in high stakes settings.
              </p>
              <p>
                By reducing administrative friction and improving financial insight, we support stronger compliance, more predictable revenue, and improved operational efficiency. This allows clinical teams to focus on delivering expert care while leadership maintains oversight and stability.
              </p>
            </CollapsibleSection>

            <CollapsibleSection title="Looking Ahead">
              <p>
                As specialized care continues to expand and evolve, strong operational foundations become even more critical.
              </p>
              <p>
                We work with specialized care facilities to build the structure, discipline, and resilience required to sustain long term performance.
              </p>
              <p>
                Let’s begin a conversation about how your organization can move forward with clarity and purpose.
              </p>
            </CollapsibleSection>
        </div>

        {/* Image Section */}
        <div className="image-container">
        {<img src={speccare} alt="Specialized Care" />}
        </div>
    </div>
    </div>

  </motion.div>
  );
};

export default SpecializedCare;
